import uniq from 'lodash/uniq';
import { getState as getRootState } from '../selectors';
import { REDUCER_NAME } from './constants';

export const getState = (state) => getRootState(state)[REDUCER_NAME];

export const getCurrency = (state) => getState(state).currency;
